import React from "react";
import "./styles.scss";
import Pagination from "@mui/lab/Pagination";
import { useStyles } from "../../../utils/styles";

function TablePaginationActionsCustom(props) {
  const classes = useStyles();
  const { count, page, onPageChange, rowsPerPage } = props;

  const handleChange = (event, value) => {
    onPageChange(value);
  };

  return (
    <div className={classes.rootPaginator}>
      <Pagination
        count={Math.ceil(count / rowsPerPage)}
        page={page + 1}
        showFirstButton={true}
        showLastButton={true}
        onChange={handleChange}
      />
    </div>
  );
}

export default TablePaginationActionsCustom;
